module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "block block--light"
  }, [_c('div', {
    staticClass: "home-block--light group group--first-last-small"
  }, [_c('h3', {
    staticClass: "h3 mt0"
  }, [_vm._v("Root Canals")]), _vm._v(" "), _vm._l((_vm.faqs), function(faq, index) {
    return _c('div', {
      key: index,
      staticClass: "root-canal-faq mt2"
    }, [_c('div', {
      staticClass: "root-canal-faq__content-wrap"
    }, [_c('img', {
      staticClass: "root-canal-faq__green-check",
      attrs: {
        "src": _vm.checkImage,
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "faq-content"
    }, [_c('h3', {
      staticClass: "h3 mt0 fw-semibold"
    }, [_vm._v(_vm._s(faq.title))]), _vm._v(" "), _c('p', {
      staticClass: "p"
    }, [_vm._v(_vm._s(faq.body))])])]), _vm._v(" "), _c('img', {
      staticClass: "root-canal-faq__illustration",
      attrs: {
        "src": faq.image,
        "alt": ""
      }
    })])
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c549c40"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/pages/understandingYourReport/RootCanalFaq.vue
// module id = 304
// module chunks = 0